import { Checkboxes } from '#/components/Checkboxes/Checkboxes';
import { Field } from '#/components/Form/Field/Field';

type Props = {
  qaId?: string;
  id?: string;
  name: string;
  label?: string;
  description?: string;
  disabled?: boolean;
  options: { value: string }[];
};

const getNewValue = ({
  value,
  option,
}: {
  value: string[];
  option: string;
}) => {
  return value.includes(option)
    ? value.filter((o) => o !== option)
    : [...value, option];
};

export function RequestedMultipleOptionField({
  id,
  name,
  label,
  description,
  disabled,
  qaId,
  options,
}: Props) {
  const subName = `${name}.option_many`;

  return (
    <Field
      name={name}
      label={label}
      description={description}
      customErrorMatch={(errors) => errors[name] ?? errors[subName]}
      renderInput={({ value, qaId: fieldQaId, updateValue }) => (
        <Checkboxes
          qaId={qaId ?? fieldQaId}
          id={id}
          disabled={disabled}
          getValue={(optionName) => value?.options.includes(optionName)}
          options={options.map((o) => ({ label: o.value, name: o.value }))}
          onChange={(optionName) => {
            const newValue = getNewValue({
              value: value?.options ?? [],
              option: optionName,
            });

            updateValue({
              type: 'OPTION_MANY',
              options: newValue,
            });
          }}
        />
      )}
    />
  );
}
